'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdBluetoothAudio = function MdBluetoothAudio(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.5 27.2l-3.1-3.2v6.3z m-3.1-17.5v6.3l3.1-3.2z m7.8 3.1l-7.2 7.2 7.2 7.2-9.6 9.4h-1.6v-12.6l-7.7 7.6-2.3-2.3 9.3-9.3-9.3-9.3 2.3-2.3 7.7 7.6v-12.6h1.6z m6.4-1.6q2.4 3.9 2.4 8.6t-2.6 8.9l-1.9-2q1.6-3.3 1.6-6.7t-1.6-6.7z m-8.8 8.8l3.8-3.8q0.8 1.9 0.8 3.8 0 2-0.8 3.9z' })
        )
    );
};

exports.default = MdBluetoothAudio;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/bluetooth-audio.js
// module id = 2849
// module chunks = 0